module.exports = __webpack_public_path__ + "img/hat05_uv_sleeve.07e02adb.svg";